import { View } from "@react-pdf/renderer";
import { useContext } from "react";
import { CAREER_KEYS_ORDER, getCareerValue } from "./careerFields";
import { DefaultPage } from "./Components";
import { CVContentContext, LanguageContext } from "./CVPDF";
import { HeaderRow, Row, Table } from "./TableComponents";
import { SmallTextPDF } from "./Texts";
import { cvTranslations } from "./translations";
export default function ProfessionalCareer() {
  const cvContent = useContext<any>(CVContentContext) || {};
  const language = useContext(LanguageContext);
  const t = cvTranslations[language];
  
  const getTranslatedKey = (key: string) => {
    const keyMap: { [key: string]: string } = {
      'Employment period': language === 'de' ? 'Beschäftigungszeitraum' : 'Employment period',
      'Position': language === 'de' ? 'Position' : 'Position',
      'Company': language === 'de' ? 'Unternehmen' : 'Company'
    };
    return keyMap[key] || key;
  };
  return (
    <DefaultPage breakPage={false}>
      <Table>
        <HeaderRow label={t.professionalCareer} />
        {(cvContent["professionalCareer"] || []).map((career, index) => (
          <Row
            key={index}
            style={{
              flexDirection: "column",
            }}
            last={index === (cvContent["professionalCareer"] || []).length - 1}
          >
            {CAREER_KEYS_ORDER.map((key) => {
              const value = getCareerValue(career, key);
              if (!value) return null;
              return (
                <View
                  key={key}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <SmallTextPDF
                    style={{
                      width: "30%",
                    }}
                  >
                    {getTranslatedKey(key)}:
                  </SmallTextPDF>
                  <View style={{
                    flex: 1
                  }}>
                    <SmallTextPDF>{value}</SmallTextPDF>
                  </View>
                </View>
              );
            })}
          </Row>
        ))}
      </Table>
    </DefaultPage>
  );
}
